import moment from 'moment-timezone';
import { findTipospublicacao } from '@/services/tipospublicacao';
import { findSegmentos } from '@/services/segmentos';
import { search } from '@/services/relatorio';
import notifyError from '@/lib/notify-error';

moment.tz.setDefault('America/Sao_Paulo');

moment.locale('pt-br');

const Getters = {
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  query(st, gt, rSt) {
    const query = [];
    if (rSt.route.query) {
      if (rSt.route.query.idTipopublicacao) {
        const data = st.tipoPublicacoes.find(seg => Number(seg.idTipopublicacao)
            === Number(rSt.route.query.idTipopublicacao));
        if (data) {
          query.push({
            title: 'Tipo de acervo',
            data: data.tipoPublicacao,
          });
        }
      } else {
        query.push({
          title: 'Tipo de acervo',
          data: 'Todos',
        });
      }
      if (rSt.route.query.idSegmento) {
        const data = st.segmentos.find(seg => Number(seg.id)
        === Number(rSt.route.query.idSegmento));
        if (data) {
          query.push({
            title: 'Área',
            data: data.segmento,
          });
        }
      } else {
        query.push({
          title: 'Área',
          data: 'Todas',
        });
      }
      if (rSt.route.query.initialDate) {
        query.push({
          title: 'Data inicial',
          data: rSt.route.query.initialDate,
        });
      }
      if (rSt.route.query.endDate) {
        query.push({
          title: 'Data final',
          data: rSt.route.query.endDate,
        });
      }
      return query;
    }
    return [];
  },
  result(st) {
    return st.result;
  },
  loading(st) {
    return st.loading;
  },
  porAcervo(st) {
    if (st.result && st.result.porAcervo) {
      return st.result.porAcervo;
    }
    return [];
  },
  porArea(st) {
    if (st.result && st.result.porArea) {
      return st.result.porArea;
    }
    return [];
  },
  csvData(st) {
    if (st.result && st.result.logs) {
      return st.result.logs.map(res => ({
        horario: moment(res.createdat).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'),
        titulo: res.publicacaoname,
        acervo: res.tipo_publicacao,
        area: res.segmento,
      }));
    }
    return [];
  },
};
const mutations = {
  setTipoPublicacoes(state, tipoPublicacoes) {
    state.tipoPublicacoes = tipoPublicacoes;
  },
  setSegmentos(state, segmentos) {
    state.segmentos = segmentos;
  },
  setResult(state, result) {
    state.result = result;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};
const actions = {
  afterRouteUpdate({ dispatch }) {
    dispatch('findTipospublicacao');
    dispatch('findSegmentos');
    dispatch('getResult');
  },
  findTipospublicacao({ commit }) {
    findTipospublicacao({ where: { base: 'S' } })
      .then(items => commit('setTipoPublicacoes', items));
  },
  findSegmentos({ commit }) {
    findSegmentos({ where: { idCanalPadrao: 273 } })
      .then(items => commit('setSegmentos', items));
  },
  getResult({ rootState, commit }) {
    commit('setLoading', true);
    const filter = Object.assign({}, rootState.route.query);
    search(filter)
      .then((result) => {
        commit('setResult', result);
      })
      .catch(err => notifyError(err))
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

export default {
  namespaced: true,
  state: {
    segmentos: [],
    tipoPublicacoes: [],
    result: {},
    loading: false,
  },
  mutations,
  getters: Getters,
  actions,
};
